import components from './components'
import mixin from './mixin/defaultMixin.js'
import plugin from './plugin'
import en from './resource/sysResource.en.js'
import zh from './resource/sysResource.zh.js'


export default {
    install: function (Vue, options) {


        if (!window.fuiNeedInitHeight) window.fuiNeedInitHeight=0
        if (!window.fuiContentWidth) window.fuiContentWidth = window.innerWidth
        window.addEventListener("resize", function(){
          //if (window.fuiSetHeightTime) clearTimeout(window.fuiSetHeightTime)
          //window.fuiSetHeightTime = setTimeout(() => {
          //  const cnt = document.querySelector("#fuiContent")
          //  if (cnt) window.fuiContentWidth = cnt.offsetWidth
          //  this.fuiInitListPanelHeight()
          //}, 300)
           //const fc = document.querySelector("#fuiContent")
           //if (fc) window.fuiContentHeight= fc.offsetHeight
        })
        
        if(!window.fuiInitListPanelHeight) window.fuiInitListPanelHeight=function(el){
          //if (!el) el = document.querySelector("#listPanel")
          //const pager = document.querySelector("#pagerPanel")
          //if (pager)  el.style.top = (pager.offsetTop + pager.offsetHeight) + "px"
        }
        
        if (!window.$fuiLoader) window.$fuiLoader = document.querySelector("#loader")
        if (!window.$fuiDownloader) window.$fuiDownloader = document.querySelector("#fuiDownload")
        if (!window.$fuiDownload) {
            window.$fuiDownload = function(link, name){
                if (!window.$fuiDownloader) window.open(link)
                else {
                    window.$fuiDownloader.href=link
                    window.$fuiDownloader.download=name
                    window.$fuiDownloader.click()
                }
            }
        }
        //console.log(window.$fuiDownload)
        if (!window.fuiTitle) window.fuiTitle = "System"




        Object.keys(plugin).forEach((key) => {
            let tmp = plugin[key]
            Object.keys(tmp).forEach((vkey) => {
                Vue.prototype["$" + vkey] = tmp[vkey]
            })
        })

        Object.keys(components).forEach((key) => {
            Vue.component(key, components[key])
        })

        Vue.mixin(mixin)


        if (!Vue.prototype.$lan) {
            const xlan = navigator.browserLanguage ? navigator.browserLanguage : navigator.language
            if (xlan.indexOf("zh") >= 0) Vue.prototype.$lan = "zh"
            else Vue.prototype.$lan = "en"
        }

        Vue.prototype.$rs = {}
        if (Vue.prototype.$lan == "zh") {
            Vue.prototype.$rs = zh
            //Vue.prototype.$extend(Vue.prototype.$rs, en, zh)
        } else {
            Vue.prototype.$rs = en
            //Vue.prototype.$extend(Vue.prototype.$rs, zh, en)
        }


    }
}